import {
    GETSUBADMINDETAILSLISTS_SUCCESS,
    GETSUBADMINDETAILSLISTS_FAILED,
    RESET_GETSUBADMINDETAILSLISTS,
    LOADING_GETSUBADMINDETAILSLISTS,
    NETWORK_ERROR_GETSUBADMINDETAILSLISTS,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetSubAdminDetailsList = () => {
    return { type: RESET_GETSUBADMINDETAILSLISTS };
};

const GetSubAdmindetailsLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETSUBADMINDETAILSLISTS });
    await adminServices
        .post("getSubAdminDetailsList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(getSubAdminDetailsListsuccess(res.data));
                    break;
                default:
                    dispatch(getSubAdminDetailsListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETSUBADMINDETAILSLISTS,
                payload: err
            });
        });
};


function getSubAdminDetailsListsuccess(data) {
    return {
        type: GETSUBADMINDETAILSLISTS_SUCCESS,
        payload: data
    };
}
function getSubAdminDetailsListFailed(data) {
    return {
        type: GETSUBADMINDETAILSLISTS_FAILED,
        payload: data
    };
}

export { GetSubAdmindetailsLists, resetGetSubAdminDetailsList }